import { buildFlags } from 'components/Flag'

export const defaultFlags = {
  'presence-v2': false,
  'collaborative-editing': false,
  'workspace-shared-with-me': false,
  'cloud-redesign-mvp': false,
  '2fa': false,
  'components-web-view': false,
  'documents-transfer-to-another-workspace': false,
  'web-canvas-mvp': false,
  'finance-role': false,
  'onboarding-licenses-signup': false,
  'page-load-metrics': false,

  // these flags are used when user is not even signed in
  // it is expected that these flags will be changed
  // using DevTools
  'workspace-sign-up-breadcrumbs': false,
  'workspace-members-filter': false,
  'filter-workspace-members': false,
} as const

export const { Flag, FlagsContext, FlagsProvider, useFlag } = buildFlags(
  defaultFlags
)

export type FlagKeys = keyof typeof defaultFlags
export type FlagsObject = { [flag in FlagKeys]: boolean }
